import React from 'react'
import { FastField } from 'formik'
import { Grid } from '@mui/material'
import { CustomTextField, FormDatePicker } from 'src/form'
import { SubSection } from './Section'

export function OverallInformationForm() {
  return (
    <SubSection title="Overall Information">
      <Grid container columnSpacing={2.5} rowSpacing={0}>
        <Grid item xs={12} md={4}>
          <FastField component={CustomTextField} fullWidth label="First name" name="FIRST_NAME" />
        </Grid>
        <Grid item xs={12} md={4}>
          <FastField component={CustomTextField} fullWidth label="Last name" name="LAST_NAME" />
        </Grid>
        <Grid item xs={12} md={4}>
          <FastField component={CustomTextField} fullWidth label="Kaiser MRN" name="MEMBER_ID" />
        </Grid>
        <Grid item xs={12} md={4}>
          <FastField component={FormDatePicker} fullWidth label="Date of event" name="date" />
        </Grid>
        <Grid item xs={0} md={8} />
        <Grid item xs={12} md={4}>
          <FastField component={CustomTextField} fullWidth label="Provider name" name="PROVIDER_NAME" />
        </Grid>
        <Grid item xs={12} md={4}>
          <FastField component={CustomTextField} fullWidth label="License type" name="LICENSE_TYPE" />
        </Grid>
      </Grid>
    </SubSection>
  )
}
